import React, { useState, useEffect } from 'react';

const initData = {
    heading: "Kullanıcı Görüşleri",
    headingText: "Kullanıcılarımızın görüşleri bizim için çok değerli. Socia kullanıcılarının deneyimlerini ve memnuniyetlerini birinci ağızdan dinleyin. Uygulamamızı kullanan farklı profildeki kullanıcılarımız, Socia'nın şehirdeki sosyal hayatlarını nasıl zenginleştirdiğini ve kolaylaştırdığını paylaşıyor.",
    headingTexttwo: " "
};

const data = [
    {
        id: "1",
        avatorImg: "/img/images.jpg",
        reviewer: "Zeynep",
        post: "Yoga Eğitmeni | Ankara",
        text: "Yoga workshop'larımı duyurmak için sosyal medyada kayboluyordum. Socia'nın 'Sağlık & Wellness' kategorisi sayesinde gerçekten ilgilenen katılımcılara ulaştım. Şimdi ayda 4 workshop düzenliyorum!",
        comments: "Mükemmel kolaylık & destek!!",
        quotIcon: "/img/quote.png",
        icon_1: "fas fa-star text-warning",
        icon_2: "fas fa-star text-warning",
        icon_3: "fas fa-star text-warning",
        icon_4: "fas fa-star text-warning",
        icon_5: "fas fa-star text-warning"
    },
    {
        id: "2",
        avatorImg: "/img/Vesikalık2.jpg",
        reviewer: "Tolga",
        post: "Sokak Sahnesi | Ankara",
        text: "Küçük bir tiyatro grubu olarak salonumuzu dolduramıyorduk. Socia ile hedef kitlemize ulaştık! İlk etkinliğimizde biletler 3 saatte tükendi. Artık her oyunumuz için Socia'yı kullanıyoruz.",
        comments: "Doğru hedef kitleye ulaşarak işimi büyüttüm!",
        quotIcon: "/img/quote.png",
        icon_1: "fas fa-star text-warning",
        icon_2: "fas fa-star text-warning",
        icon_3: "fas fa-star text-warning",
        icon_4: "fas fa-star text-warning",
        icon_5: "fas fa-star-half-alt text-warning"
    },
    {
        id: "3",
        avatorImg: "/img/original.jpg",
        reviewer: "Selin",
        post: "Ev Hanımı | Ankara",
        text: "Çocuklarımla katılabileceğim etkinlikler ararken Socia'nın 'Aile Dostu' filtresiyle karşılaştım. Şimdi her hafta sonu orman yürüyüşleri veya geri dönüşüm atölyelerine gidiyoruz. Hem öğreniyoruz hem eğleniyoruz!",
        comments: "Ailemle kaliteli zaman geçirmenin yeni yolu!",
        quotIcon: "/img/quote.png",
        icon_1: "fas fa-star text-warning",
        icon_2: "fas fa-star text-warning",
        icon_3: "fas fa-star text-warning",
        icon_4: "fas fa-star text-warning",
        icon_5: "fas fa-star text-warning"
    }
];

const ReviewSection = () => {
    const [reviewData, setReviewData] = useState([]);
    const [reviewInitData, setReviewInitData] = useState({});

    useEffect(() => {
        setReviewData(data);
        setReviewInitData(initData);
    }, []);

    return (
        <section 
            id="review" 
            className="review-area ptb_100"
            style={{ 
                background: 'radial-gradient(circle, #2F2D51 0%, #1A1E28 100%)',
                color: 'white'
            }}
        >
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-10 col-lg-8">
                        {/* Section Heading */}
                        <div className="section-heading text-center">
                            <h2 className="text-capitalize" style={{ color: 'white' }}>{reviewInitData.heading}</h2>
                            <p className="d-none d-sm-block mt-4" style={{ color: 'white' }}>{reviewInitData.headingText}</p>
                            <p className="d-block d-sm-none mt-4" style={{ color: 'white' }}>{reviewInitData.headingTexttwo}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {reviewData.map((item) => (
                        <div key={item.id} className="col-12 col-md-6 col-lg-4 res-margin">
                            {/* Single Review */}
                            <div className="single-review card">
                                {/* Card Top */}
                                <div className="card-top p-4">
                                    <div className="review-icon">
                                        <i className={item.icon_1} />
                                        <i className={item.icon_2} />
                                        <i className={item.icon_3} />
                                        <i className={item.icon_4} />
                                        <i className={item.icon_5} />
                                    </div>
                                    <h4 className="text-primary mt-4 mb-3">{item.comments}</h4>
                                    {/* Review Text */}
                                    <div className="review-text">
                                        <p>{item.text}</p>
                                    </div>
                                    {/* Quotation Icon */}
                                    <div className="quot-icon">
                                        <img className="avatar-md" src={item.quotIcon} alt="" />
                                    </div>
                                </div>
                                {/* Reviewer */}
                                <div className="reviewer media bg-gray p-4">
                                    {/* Reviewer Thumb */}
                                    <div className="reviewer-thumb">
                                        <img className="avatar-lg radius-100" src={item.avatorImg} alt="" />
                                    </div>
                                    {/* Reviewer Media */}
                                    <div className="reviewer-meta media-body align-self-center ml-4">
                                        <h5 className="reviewer-name color-primary mb-2">{item.reviewer}</h5>
                                        <h6 className="text-secondary fw-6">{item.post}</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ReviewSection;